var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12760_2061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88232 2.5265C2.88232 1.68439 3.70585 1.68439 3.70585 0.842285",
    stroke: "#5B5BD6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76465 2.5265C5.76465 1.68439 6.58818 1.68439 6.58818 0.842285",
    stroke: "#5B5BD6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64697 2.5265C8.64697 1.68439 9.4705 1.68439 9.4705 0.842285",
    stroke: "#5B5BD6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.82373 4.63135L1.64726 13.0524C1.64726 13.5156 2.01785 13.8945 2.47079 13.8945H9.05902C9.51197 13.8945 9.88255 13.5156 9.88255 13.0524L10.7061 4.63135H0.82373Z",
    fill: "#5B5BD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7061 6.31592C12.3531 6.31592 13.1766 7.15802 13.1766 8.42118C13.1766 9.68434 12.3531 10.5264 10.7061 10.5264",
    stroke: "#5B5BD6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12760_2061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.ef1f1b06.svg";
export { ForwardRef as ReactComponent };